export enum ApplicationType {
  RETAIL = 'SPPI',
  WORKPLACE = 'SPWI',
  SEC = 'SHLDR',
  FILI = 'FILI',
  FILI_SEC = 'SHLDR-FILI'
}
